<template>
  <div class="category-star" :class="context">
    <div class="circle is-flex" :class="{'bigger-circle': bigger, 'isef-circle': this.$isIsef}">
      <div class="is-centered">
        <span>
          <i class="fas fa-star"></i>
        </span>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  props: [
    'context' // (big, small, modal-star, profile, user-select)
  ],
  data: function () {
    return {
      open: false
    }
  },
  computed: {
    bigger: function () {
      return this.context === 'homepage-interests'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.fa {
  font-size: 0.7rem;
  color: $primary;
}
.fa, .fas, .far, .fal, .fad, .fab {
  display: block !important;
}
.is-centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
.circle {
  background-color: white;
  color: $primary;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  justify-content: center;
  align-items: center;
  align-content: center;
  @include shadow;
}
// context is big : home top row
.big {
  position: absolute;
  right: 0.75rem;
}
// context is small : `My Categories` title small images
.small {
  position: absolute;
  right: -0.5rem;
  bottom: 0;
}
// context is modal-star: selecting categories modal
.modal-star {
  position: absolute;
  right: 0;
  bottom: 0;
}

// context is profile
.profile {
  position: absolute;
  bottom: 0;
  right: 0;
}
// context is user-select
.user-select {
  .fas {
    font-size: 0.85rem;
  }
}
// context is homepage interests
.homepage-interests {
  .fas {
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.isef-circle {
  background-color: orange !important;
  color: white !important;
}

.bigger-circle {
  height: 1.75rem;
  width: 1.75rem;
}

@include mobile {
  [data-balloon]:after {
    font-size: .6rem !important;
    margin-bottom: 10px !important;
  }
}

</style>
